import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthenticationService } from '@next/core-lib/authentication';
import { PageToolbarComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  imports: [PageToolbarComponent, MatButton, MatIcon, TranslatePipe],
})
export class UnauthorizedComponent {
  constructor(
    private readonly router: Router,
    private readonly authentication: AuthenticationService,
  ) {}

  logout() {
    this.authentication.logout();
    this.router.navigate(['/']);
  }
}
